import React, { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';
import Header from '../dashboard/header';
import Navbar from '../dashboard/navbar';
import Sidebar from '../dashboard/sidebar';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import CommentaireAdmin from './admin_commentaire';
import useAuth from '../dashboard/useAuth';
import { FaArrowAltCircleRight, FaUserShield } from 'react-icons/fa';
import axios from 'axios';
import { getAuthToken } from '../../authToken';

const Eligibilite_admin = () => {
    useAuth(); // Authentication required

    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const [isLoading, setIsLoading] = useState(false); // Ajout du state de chargement

    const user_id = localStorage.getItem('user_id');
    const utilisateur_id = localStorage.getItem('utilisateur_id');

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Eligibilite"; // Définit le titre de la page
        }
    }, [user_id]);

    const [userData, setUserData] = useState({
        email: '',
        nom: '',
        prenoms: '',
        tel: '',
    });

    const [formulaire_id, setFormulaireId] = useState(null);

    const [formData, setFormData] = useState({
        niveau_eleve: "",
        annee_debut_education: "",
        annee_fin_education: "",
        pays: "",
        institution: "",
        filiere: "",
        lieu_formation: "",
        titre_cours: "",
        date_debut_cours: "",
        date_fin_cours: "",
        nombre_heures: ""
    });


    useEffect(() => {
        const fetchUserData = async () => {
            try {
                    const token = localStorage.getItem('access_token');
            
                    const response = await fetch(`${process.env.REACT_APP_HOTE}/recup-info-profil/${utilisateur_id}/`, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}` // À inclure si nécessaire
                        },
                    });
                if (!response.ok) throw new Error('Erreur réseau');
                const data = await response.json();
                setUserData(data);
            } catch (error) {
                console.error('Erreur lors de la récupération des données utilisateur:', error);
            }
        };

        const fetchFormData = async () => {
            setIsLoading(true);
            try {
                const token = localStorage.getItem('access_token');

                const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-eligibilite-pour-admin/${utilisateur_id}/`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
                // const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-eligibilite-pour-admin/${utilisateur_id}/`);
                if (!response.ok) throw new Error('Erreur réseau');
                const data = await response.json();
                setFormData(data);
                console.log("données expériences admin : ", data);

                if (data.id) {
                    setFormulaireId(data.id);
                }
            } catch (error) {
                console.error('Erreur lors de la récupération des données du formulaire:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchUserData();
        fetchFormData();
    }, [utilisateur_id]);

    const handleSubmit = async (e) => {
        // navigate(`/Experience_form?user_id=${user_id}&formData=${JSON.stringify(formData)}`);
        navigate(`/Experience-form-admin`, { state: { userData } });
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("AdminEligibilite")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper" style={{ fontFamily: 'Arial, sans-serif' }}>
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><FaUserShield size={25} className='mr-2' />Dossier de {userData.nom} {userData.prenoms} </h2>
                            <small>Administration des Eligibilités.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {/* Utiliser Link de react-router-dom pour la navigation */}
                                        <Link to={`/admin`}>Administraion</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {/* Utiliser Link de react-router-dom pour la navigation */}
                                        <Link to={`/Eligibilites-soumises`}>Eligibilite</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {/* Utiliser Link de react-router-dom pour la navigation */}
                                        <span>Dossier de {userData.nom} {userData.prenoms} </span>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    {/* <Header titre="Eligibilité" sous_titre="Dashboard" sous_titre1="Eligibilite" /> */}
                    <div className="d-flex flex-wrap justify-content-between" style={{ display: 'flex' }}>
                        <div className="col-lg-8 col-md-6 col-sm-12 mx-auto m-4">

                            {isLoading ? (
                                <div className="text-center">
                                    <p>Chargement des données...</p> {/* Affichage d'un message de chargement */}
                                </div>
                            ) : (
                                <div className="ibox-content">
                                    <h3 className="text-success" style={{ marginBottom: '0px', textTransform: 'uppercase', fontSize: '13px' }}>Identification</h3>
                                    <hr className="mt-2 text-success" style={{ borderTop: '1px solid' }} />
                                    <Form onSubmit={handleSubmit} className="w-100">
                                        <div className="row" style={{ marginBottom: "10px" }}>
                                            <div className="col-lg-6">
                                                <Form.Group controlId="prenoms">
                                                    <Form.Label style={{ display: 'block' }}> Prénoms<small style={{ display: 'block' }}>Firstname</small></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={userData.prenoms}
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="col-lg-6">
                                                <Form.Group controlId="nom">
                                                    <Form.Label style={{ display: 'block' }}> Nom <small style={{ display: 'block' }}>Name</small></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={userData.nom}
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </div>
                                        </div>

                                        <div className="row" style={{ marginBottom: "25px" }}>
                                            <div className="col-lg-6">
                                                <Form.Group controlId="email">
                                                    <Form.Label style={{ display: 'block' }}> Email <small style={{ display: 'block' }}>Mail</small></Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        value={userData.email}
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </div>
                                            <div className="col-lg-6">
                                                <Form.Group controlId="tel">
                                                    <Form.Label style={{ display: 'block' }}> Numéro de téléphone <small style={{ display: 'block' }}>Phone number</small></Form.Label>
                                                    <Form.Control
                                                        type="tel"
                                                        value={userData.tel}
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </div>
                                        </div>

                                        <h3 className="text-success" style={{ marginBottom: '0px', textTransform: 'uppercase', fontSize: '13px' }}>Academic Education/ Éducation académique</h3>
                                        <hr className="mt-2 text-success" style={{ borderTop: '1px solid' }} />

                                        <div className="row">
                                            <div className="col-lg-6">
                                                <Form.Group controlId="niveau_eleve" className="mb-3">
                                                    <Form.Label style={{ display: 'block' }}> Niveau élevé d'éducation* <small style={{ display: 'block' }}>Highest level of education*</small></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.niveau_eleve}
                                                        disabled
                                                    >
                                                    </Form.Control>
                                                </Form.Group>
                                            </div>

                                            <div className="col-lg-3">
                                                <Form.Group controlId="annee_debut_education" className="mb-3">
                                                    <Form.Label style={{ display: 'block' }}> Année Début* <small style={{ display: 'block' }}>Start Year*</small></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.annee_debut_education}
                                                        disabled
                                                    >
                                                    </Form.Control>
                                                </Form.Group>
                                            </div>

                                            <div className="col-lg-3">
                                                <Form.Group controlId="annee_fin_education" className="mb-3">
                                                    <Form.Label style={{ display: 'block' }}> Année Fin* <small style={{ display: 'block' }}>End Year*</small></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.annee_fin_education}
                                                        disabled
                                                    >
                                                    </Form.Control>
                                                </Form.Group>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-lg-3">
                                                <Form.Group controlId="pays" className="mb-3">
                                                    <Form.Label style={{ display: 'block' }}> Pays* <small style={{ display: 'block' }}>Country*</small></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.pays}
                                                        disabled
                                                    >
                                                    </Form.Control>
                                                </Form.Group>
                                            </div>

                                            <div className="col-lg-5">
                                                <Form.Group controlId="institution" className="mb-3">
                                                    <Form.Label style={{ display: 'block' }}> Nom de l'institution* <small style={{ display: 'block' }}>Name of institution*</small></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.institution}
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </div>

                                            <div className="col-lg-4">
                                                <Form.Group controlId="filiere" className="mb-3">
                                                    <Form.Label style={{ display: 'block' }}> Filière* <small style={{ display: 'block' }}>Field of study*</small></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.filiere}
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </div>
                                        </div>

                                        <h3 className="text-success" style={{ marginBottom: '0px', textTransform: 'uppercase', fontSize: '13px' }}>Professional Education/ Formation Professionnelle :</h3>
                                        <hr className="mt-2 text-success" style={{ borderTop: '1px solid' }} />

                                        <div className="row">
                                            <div className="col-lg-6">
                                                <Form.Group controlId="lieu_formation" className="mb-3">
                                                    <Form.Label style={{ display: 'block' }}> Lieu de formation* <small style={{ display: 'block' }}>Provider Name*</small></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.lieu_formation}
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </div>

                                            <div className="col-lg-6">
                                                <Form.Group controlId="titre_cours" className="mb-3">
                                                    <Form.Label style={{ display: 'block' }}> Titre du cours* <small style={{ display: 'block' }}>Course Title*</small></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={formData.titre_cours}
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-lg-4">
                                                <Form.Group controlId="date_debut_cours" className="mb-3">
                                                    <Form.Label style={{ display: 'block' }}> Date début* <small style={{ display: 'block' }}>Start date*</small></Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        value={formData.date_debut_cours}
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </div>

                                            <div className="col-lg-4">
                                                <Form.Group controlId="date_fin_cours" className="mb-3">
                                                    <Form.Label style={{ display: 'block' }}> Date Fin* <small style={{ display: 'block' }}>End date*</small></Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        value={formData.date_fin_cours}
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </div>

                                            <div className="col-lg-4">
                                                <Form.Group controlId="nombre_heures" className="mb-3">
                                                    <Form.Label style={{ display: 'block' }}> Nombre total d'heures* <small style={{ display: 'block' }}>Qualifying Hours*</small></Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        value={formData.nombre_heures}
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </div>
                                        </div>
                                        <div className="d-flex mt-5 justify-content-end">
                                            <Button variant="success" type="submit">Suivant<FaArrowAltCircleRight className='ml-1' /></Button>
                                        </div>
                                    </Form>
                                </div>
                            )}
                        </div>
                        <div className="col-lg-4 col-md-6 mx-auto col-sm-12 m-4 ">
                            <div className="ibox-content">
                                <h4 className="text-success" style={{ textTransform: 'uppercase', }}>Commentaires</h4>
                                <hr className="mt-2 text-success" style={{ borderTop: '1px solid' }} />
                                <CommentaireAdmin formulaire_id={formulaire_id} user_id={user_id} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Eligibilite_admin;
